import React from 'react'
import { countryCodeToEmojiFlag } from '@carsys/form/src/CountriesDropdownBase'
import { Box, ListSubheader, MenuItem, Select, SelectChangeEvent, outlinedInputClasses } from '@mui/material'
import { CountryAreaCode, countryAreaCodesCommon, countryAreaCodesDefaults } from './countryAreaCodes'
import { useTranslation } from 'react-i18next'

interface CountryAreaCodeSelectProps {
  disabled?: boolean
  onChange: (event: SelectChangeEvent<string>) => void
  areaCode: CountryAreaCode
}

export const CountryAreaCodeSelect: React.FC<CountryAreaCodeSelectProps> = props => {
  const sortedCountryPhoneCodes = countryAreaCodesCommon.sort(
    (cacA, cacB) => Number(cacA.dialCode.substring(1)) - Number(cacB.dialCode.substring(1))
  )
  const { t } = useTranslation()

  return (
    <Select
      data-testid='phone-number-dropdown'
      size='small'
      disabled={props.disabled}
      value={props.areaCode.dialCode}
      onChange={(event: SelectChangeEvent<string>) => {
        props.onChange(event)
      }}
      sx={{
        [`& .${outlinedInputClasses.notchedOutline}`]: {
          borderRight: 'none',
          borderRadius: Theme => `${Theme.shape.borderRadius}px 0 0 ${Theme.shape.borderRadius}px`
        },
        alignSelf: 'start'
      }}
    >
      <ListSubheader color='primary' key='RecommendedCountryCodes'>
        {t('global.phone-number-dropdown-header-recommended')}
      </ListSubheader>
      {countryAreaCodesDefaults.map((code, index) => (
        <MenuItem key={`select-option-${index}-${code.name}`} value={code.dialCode}>
          <Box component='span' className='emoji-flag' sx={{ mr: 1 }}>
            {countryCodeToEmojiFlag(code.code) || '\u00A0'}
          </Box>
          {code.dialCode}
        </MenuItem>
      ))}
      <ListSubheader color='primary' key='OtherCountryCodes'>
        {t('global.phone-number-dropdown-header-others')}
      </ListSubheader>
      {sortedCountryPhoneCodes.map((code, index) => (
        <MenuItem key={`select-option-${index}-${code.name}`} value={code.dialCode}>
          <Box component='span' className='emoji-flag' sx={{ mr: 1 }}>
            {countryCodeToEmojiFlag(code.code) || '\u00A0'}
          </Box>
          {code.dialCode}
        </MenuItem>
      ))}
    </Select>
  )
}
